import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React from 'react';
import { object } from 'prop-types';
import get from 'lodash.get';
import merge from 'lodash.merge';
import isString from 'lodash.isstring';
import kebabCase from 'lodash.kebabcase';
import isNumber from 'lodash.isnumber';
import memoize from 'lodash.memoize';
import isPlainObject from 'lodash.isplainobject';
import IntlFormat from 'intl-messageformat';

var _excluded = ["translations"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_LOCALE = 'de_DE';
var defaultOptions = {
  fallbackToKey: true
};

var _React$createContext = /*#__PURE__*/React.createContext(DEFAULT_LOCALE),
    TranslationProvider = _React$createContext.Provider,
    TranslationConsumer = _React$createContext.Consumer;

var CURRENCY_BY_REGION = {
  AT: 'EUR',
  CH: 'CHF',
  DE: 'EUR',
  FR: 'EUR',
  GB: 'GPB',
  US: 'USD'
};

var getMoneyFormat = function getMoneyFormat(locale) {
  return {
    number: {
      money: {
        currency: CURRENCY_BY_REGION[locale.slice(-2)],
        minimumFractionDigits: 0,
        style: 'currency'
      }
    }
  };
};

var createWithTranslation = function createWithTranslation() {
  var globalTranslations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  var globalFormats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var withTranslation = function withTranslation() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        translations = _ref.translations,
        _ref$formats = _ref.formats,
        formats = _ref$formats === void 0 ? {} : _ref$formats,
        _ref$scope = _ref.scope,
        scope = _ref$scope === void 0 ? null : _ref$scope;

    var preHeatedTranslations = merge({}, globalTranslations, translations);
    return function (Component) {
      var _class;

      var displayName = Component.displayName || Component.name || 'withTranslation(Component)';
      return _class = /*#__PURE__*/function (_React$Component) {
        _inherits(WrappedComponent, _React$Component);

        var _super = _createSuper(WrappedComponent);

        function WrappedComponent() {
          var _this;

          _classCallCheck(this, WrappedComponent);

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = _super.call.apply(_super, [this].concat(args));

          _defineProperty(_assertThisInitialized(_this), "warnAboutMissingTranslation", function (key) {
            if (process.env.NODE_ENV !== 'production') {
              console.warn("".concat(displayName, ": Key \"").concat(key, "\" was not found. Falling back to the key as translation"));
            }

            return key.split('.').pop();
          });

          _defineProperty(_assertThisInitialized(_this), "getTranslateFunc", memoize(function (propsTranslations) {
            var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLocale;
            var mergedFormats = merge({}, getMoneyFormat(locale), globalFormats[locale], formats[locale]);

            var translateFunc = function translateFunc(key, translateOptions) {
              var lookupKey = scope ? "".concat(scope, ".").concat(key) : key;

              var options = _objectSpread(_objectSpread({}, defaultOptions), translateOptions);

              var value = get(propsTranslations[locale], lookupKey) || get(preHeatedTranslations[locale], lookupKey) || get(propsTranslations[defaultLocale], lookupKey) || get(preHeatedTranslations[defaultLocale], lookupKey) || (options.fallbackToKey ? _this.warnAboutMissingTranslation(lookupKey) : null); // Return the formatted string for numbers and strings

              if (isNumber(value) || isString(value)) {
                var result = new IntlFormat(value, kebabCase(locale), mergedFormats);
                return result.format(_objectSpread(_objectSpread({}, _this.props), options));
              } // Return another translate function for enum properties


              if (isPlainObject(value)) return function (subkey) {
                return translateFunc("".concat(key, ".").concat(subkey), options);
              };
              return value;
            };

            return translateFunc;
          }));

          return _this;
        }

        _createClass(WrappedComponent, [{
          key: "render",
          value: function render() {
            var _this2 = this;

            var _this$props = this.props;
                _this$props.translations;
                var props = _objectWithoutProperties(_this$props, _excluded);

            return /*#__PURE__*/React.createElement(TranslationConsumer, null, function (locale) {
              return /*#__PURE__*/React.createElement(Component, _extends({
                translate: _this2.getTranslateFunc(_this2.props.translations, locale)
              }, props));
            });
          }
        }]);

        return WrappedComponent;
      }(React.Component), _defineProperty(_class, "propTypes", {
        translations: object
      }), _defineProperty(_class, "defaultProps", {
        translations: {}
      }), _class;
    };
  };

  return withTranslation;
};

var withTranslation = createWithTranslation({});

export { TranslationProvider, createWithTranslation, withTranslation };
